/* global app */
/* global event */
/* global groups */
app.controller('groupsCtrl', ['$rootScope', '$scope', '$http', '$compile', 'NetworkService', 'AtlasDialog', 'AtlasNotification', function($rootScope, $scope, $http, $compile, NetworkService, AtlasDialog, AtlasNotification) {

    $scope.groups = groups;
    $scope.search = "";
    
    $rootScope.$on("ACDataTable:groupsTable:finished", function(){
        $scope.dataTables.groupsTable.saveEntry = function(){
            var data = $scope.dataTables.groupsTable.phantomFields;
            NetworkService.callOperation("addGroup", data, function(response){
                if(response.isSuccessfull()){
                    AtlasNotification.info("Gruppe wurde erfolgreich hinzugefügt.");
                }

                NetworkService.callOperation("reload/groups", {}, function(response){
                    $scope.groups = response.get("groups");
                })
            })
        }
    })
    
    $scope.openGroup = function(group){
        if(group.Type == "VIRTUALATTENDEES"){
            window.location = "/virtualattendees/"+group.Veranstaltungsnummer
        }else if(group.Type == "REAL"){
            window.location = "/group/"+group.groupId
        }
        
    }
}])
